import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { formatQAR } from "../lib/money";
const CUSTODY_OPTIONS = ["With Legal Firm", "With Company", "At Bank", "With Court"];
export function ChequesPanel({ caseId, canRequestReturn = true }) {
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [saving, setSaving] = useState(false);
    const [chequeNumber, setChequeNumber] = useState("");
    const [bank, setBank] = useState("");
    const [amount, setAmount] = useState("");
    const [chequeDate, setChequeDate] = useState(new Date().toISOString().slice(0, 10));
    const [currentCustody, setCurrentCustody] = useState(CUSTODY_OPTIONS[0]);
    const [fieldErrors, setFieldErrors] = useState({});
    function load() {
        api.get(`/cases/${caseId}/cheques`).then((r) => setItems(r.items)).catch(() => setError("Couldn't load cheques."));
    }
    useEffect(load, [caseId]);
    async function create() {
        const errs = {};
        if (!chequeNumber.trim())
            errs.chequeNumber = "Cheque number is required.";
        if (!bank.trim())
            errs.bank = "Bank is required.";
        if (!amount || Number(amount) <= 0)
            errs.amount = "Enter a valid amount.";
        setFieldErrors(errs);
        if (Object.keys(errs).length)
            return;
        setSaving(true);
        setError(null);
        try {
            await api.post(`/cases/${caseId}/cheques`, {
                chequeNumber: chequeNumber.trim(),
                chequeDate: new Date(chequeDate).toISOString(),
                bank: bank.trim(),
                amount: Number(amount),
                currentCustody,
            });
            setChequeNumber("");
            setBank("");
            setAmount("");
            setShowForm(false);
            load();
        }
        catch {
            setError("Couldn't save this cheque.");
        }
        finally {
            setSaving(false);
        }
    }
    // RETURNED is never set directly - it goes through the CHEQUE_RETURN
    // approval, which flips the status once Management approves it.
    async function requestReturn(c) {
        const reason = window.prompt(`Why should cheque ${c.chequeNumber} be returned to the customer?`);
        if (!reason || !reason.trim())
            return;
        setError(null);
        try {
            await api.post(`/cases/${caseId}/actions/return-cheque`, { chequeId: c.id, reason: reason.trim() });
            window.alert("Return requested — it takes effect once approved (see the Approvals tab).");
        }
        catch (e) {
            setError(e?.message && e.status !== 0 ? e.message : "Couldn't request the return.");
        }
    }
    return (<div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid var(--line-soft)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <h4 style={{ fontSize: "0.8rem", color: "var(--ink-faint)", textTransform: "uppercase", margin: 0 }}>Cheques</h4>
        <button onClick={() => setShowForm((v) => !v)} style={actionBtn}>{showForm ? "Cancel" : "+ Add Cheque"}</button>
      </div>

      {error && <div style={{ color: "var(--st-risk)", fontSize: "0.85rem", marginBottom: 10 }}>{error}</div>}

      {showForm && (<div className="lg-stack" style={formBox}>
          <div>
            <input placeholder="Cheque number" value={chequeNumber} onChange={(e) => setChequeNumber(e.target.value)} style={inputStyle}/>
            {fieldErrors.chequeNumber && <div style={errText}>{fieldErrors.chequeNumber}</div>}
          </div>
          <div>
            <input placeholder="Bank" value={bank} onChange={(e) => setBank(e.target.value)} style={inputStyle}/>
            {fieldErrors.bank && <div style={errText}>{fieldErrors.bank}</div>}
          </div>
          <div>
            <input placeholder="Amount (QAR)" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} style={inputStyle}/>
            {fieldErrors.amount && <div style={errText}>{fieldErrors.amount}</div>}
          </div>
          <input type="date" value={chequeDate} onChange={(e) => setChequeDate(e.target.value)} style={inputStyle}/>
          <select value={currentCustody} onChange={(e) => setCurrentCustody(e.target.value)} style={inputStyle}>
            {CUSTODY_OPTIONS.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <button onClick={create} disabled={saving} style={actionBtn}>Save</button>
        </div>)}

      {items.map((c) => (<div key={c.id} style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderTop: "1px solid var(--line-soft)", fontSize: "0.85rem" }}>
          <span>
            {c.chequeNumber} · {c.bank} · {new Date(c.chequeDate).toLocaleDateString()}
          </span>
          <span className="mono" style={{ color: "var(--ink-faint)" }}>{c.status} · {c.currentCustody}</span>
          <span className="mono tabnum">{formatQAR(c.amount)}</span>
          {canRequestReturn && c.status !== "RETURNED" ? (<button onClick={() => requestReturn(c)} style={{ ...actionBtn, padding: "3px 9px", fontSize: "0.72rem" }}>Request return</button>) : <span />}
        </div>))}
      {items.length === 0 && !error && <div style={{ color: "var(--ink-faint)", fontSize: "0.85rem" }}>No cheques recorded for this case.</div>}
    </div>);
}
const actionBtn = { border: "1px solid var(--line)", background: "var(--surface)", color: "var(--ink-soft)", fontWeight: 600, fontSize: "0.8rem", padding: "7px 12px", borderRadius: 8, cursor: "pointer" };
const formBox = { border: "1px solid var(--line-soft)", borderRadius: 8, padding: 14, marginBottom: 16, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 };
const inputStyle = { border: "1px solid var(--line)", borderRadius: 8, padding: "8px 10px", fontSize: "0.82rem", fontFamily: "inherit" };
const errText = { color: "var(--st-risk)", fontSize: "0.7rem", marginTop: 2 };
